import React from 'react';
import { openInAppBrowser } from '../../utils/capacitor';

/**
 * FatSecret attribution badge — REQUIRED by FatSecret Platform API Basic-tier
 * terms of service whenever their data is displayed. Renders a small,
 * unobtrusive "Powered by fatsecret" link that opens https://www.fatsecret.com.
 *
 * Spec: https://platform.fatsecret.com/api-editions
 */
export default function FatSecretAttribution({ className = '' }) {
  return (
    <div
      className={`flex items-center justify-center py-3 ${className}`}
      data-testid="fatsecret-attribution"
    >
      <a
        href="https://www.fatsecret.com"
        onClick={(e) => { e.preventDefault(); openInAppBrowser('https://www.fatsecret.com'); }}
        className="text-[11px] text-muted-foreground hover:text-foreground transition-colors cursor-pointer"
      >
        Powered by{' '}
        <span className="font-semibold tracking-wide">fatsecret</span>
      </a>
    </div>
  );
}
